import { useEffect, type RefObject } from 'react'

/** Closes on a pointer down outside every given element, or on Escape. */
export function useClickOutside(refs: RefObject<HTMLElement | null>[], active: boolean, handler: () => void) {
  useEffect(() => {
    if (!active) return
    const onPointer = (event: PointerEvent) => {
      const target = event.target as Node
      if (!refs.some((ref) => ref.current?.contains(target))) handler()
    }
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') handler()
    }
    document.addEventListener('pointerdown', onPointer)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('pointerdown', onPointer)
      document.removeEventListener('keydown', onKey)
    }
    // refs is a fresh array each render; the ref objects themselves are stable.
  }, [active, handler]) // eslint-disable-line react-hooks/exhaustive-deps
}
